import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

// import stt from "@/store/modules/stt";
import doc from "@/store/modules/doc";
import user from "@/store/modules/user";
import room from "@/store/modules/room";
import invite from "@/store/modules/invite";
import call from "@/store/modules/call";
import chat from "@/store/modules/chat";
import chatBot from "@/store/modules/chatBot";
import auth from "@/store/modules/auth";
import file from "@/store/modules/file"
import testbank from "@/store/modules/testbank";
import note from "@/store/modules/note";
import roomGroup from "@/store/modules/roomGroup";
import notice from "@/store/modules/notice";
import record from "@/store/modules/record";
import common from "@/store/modules/common";
import contents from "@/store/modules/contents"
import question from "@/store/modules/question";
import rollBook from "@/store/modules/rollBook";
import shareNote from "@/store/modules/shareNote";
import media from "@/store/modules/media";
import waitingRoom from "@/store/modules/waitingRoom";
import group from "@/store/modules/group";
import roomSetting from "@/store/modules/roomSetting";
import exam from "@/store/modules/exam";
import sticker from "@/store/modules/sticker";
import meetingNote from "@/store/modules/meetingNote";
import urlShare from "@/store/modules/urlShare";
import ux from "@/store/modules/ux";
import lms from "@/store/modules/lms";
import cbt from "@/store/modules/cbt";
import translation from "@/store/modules/translation";
import camstudy from "@/store/modules/camstudy";
import coordi from "@/store/modules/coordi"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    // stt,
    doc,
    user,
    room,
    invite,
    call,
    chat,
    chatBot,
    auth,
    file,
    testbank,
    note,
    roomGroup,
    notice,
    record,
    common,
    contents,
    question,
    rollBook,
    shareNote,
    media,
    waitingRoom,
    group,
    roomSetting,
    exam,
    sticker,
    urlShare,
    meetingNote,
    ux,
    lms,
    cbt,
    translation,
    camstudy,
    coordi,
  },
  plugins: [
    createPersistedState({
      paths: ['auth']
    })
  ],
  strict: process.env.NODE_ENV !== 'production'
})
